import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const LoadingText = styled.div`
  font-size: 18px;
  color: #666;
`;

const ProtectedRoute = ({ children, requiredType = null, requiredTypes = null }) => {
  const { isAuthenticated, userProfile, isInitialized } = useAuthStore();

  // 초기 인증 체크가 완료되지 않은 경우 로딩 표시
  if (!isInitialized) {
    return (
      <LoadingContainer>
        <LoadingText>로딩 중...</LoadingText>
      </LoadingContainer>
    );
  }

  // 인증되지 않은 경우 로그인 페이지로
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 특정 사용자 타입이 필요한 경우 체크
  if (requiredType && userProfile?.type !== requiredType) {
    return <Navigate to="/dashboard/info" replace />;
  }

  // 여러 사용자 타입 중 하나가 필요한 경우 체크
  if (requiredTypes && Array.isArray(requiredTypes) && !requiredTypes.includes(userProfile?.type)) {
    return <Navigate to="/dashboard/info" replace />;
  }

  return children;
};

export default ProtectedRoute;
